/**
 * Phase 93 (Plan 93-01, Task 2) — extracted verbatim from `App.tsx:111-121`
 * (previously a local, unexported const) so both the catch-all `*` route and
 * `RequireModule` (a disabled module renders this in place) can share one
 * component.
 */
export const NotFoundPage = () => (
  <div className="flex min-h-screen items-center justify-center">
    <div className="text-center">
      <h1 className="text-4xl font-bold text-gray-900">404</h1>
      <p className="mt-2 text-gray-500">Page not found</p>
      <a href="/" className="mt-4 inline-block text-primary-600 hover:underline">
        Go home
      </a>
    </div>
  </div>
);
